import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { path: '/monitor', icon: 'fas fa-tachometer-alt', label: '监控' },
    { path: '/analysis', icon: 'fas fa-chart-line', label: '分析' },
    { path: '/diagnosis', icon: 'fas fa-stethoscope', label: '诊断' },
    { path: '/alarm', icon: 'fas fa-bell', label: '报警' },
    { path: '/device', icon: 'fas fa-cogs', label: '设备' },
    { path: '/profile', icon: 'fas fa-user-circle', label: '我的' },
  ];

  const handleTabClick = (path) => {
    navigate(path);
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-16">
      {/* 主内容区域 */}
      <div className="px-4">
        {children}
      </div>

      {/* 底部导航栏 */}
      <div className="iphone-tabbar">
        {tabs.map((tab) => (
          <div
            key={tab.path}
            className={`tab-item ${location.pathname === tab.path ? 'active' : ''}`}
            onClick={() => handleTabClick(tab.path)}
          >
            <i className={tab.icon}></i>
            <span>{tab.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Layout;
